export const EXPERIMENTS = {
    CHAMS_DUMMY_SEGMENTATION_JP: 4753,
    LYNXES_JP_HIGH_SPEND_POTENTIAL: 5122,
} as const;
